export default __webpack_public_path__ + "img/app-page/screen2Android.4c29d00da374ea6c3ed14196e83ee446.png";